import { render, staticRenderFns } from "./DataTransfer.vue?vue&type=template&id=5bed2bf8"
import script from "./DataTransfer.vue?vue&type=script&lang=js"
export * from "./DataTransfer.vue?vue&type=script&lang=js"
import style0 from "./DataTransfer.vue?vue&type=style&index=0&id=5bed2bf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports